import { Box, Button, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ApiOutlinedIcon from '@mui/icons-material/ApiOutlined';
import { useTranslation } from 'react-i18next';
import { K } from '../apiServiceI18n';

export default function ApiServiceBlankState({ canModify, onCreateApi }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
        bgcolor: '#fafbfc',
        borderRadius: 2,
        border: '1px dashed #c5cad3',
      }}
    >
      <ApiOutlinedIcon sx={{ fontSize: 56, color: 'primary.main', opacity: 0.7 }} />
      <Typography variant="h6" color="text.primary">
        {t(K.API_SVC_BLANK_TITLE)}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {t(K.API_SVC_BLANK_BODY)}
      </Typography>
      {canModify && (
        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={onCreateApi}
          sx={{ mt: 1 }}
        >
          {t(K.API_SVC_CREATE_API)}
        </Button>
      )}
    </Box>
  );
}
